module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921080834_T.ea128e92.jpg";